import lottie from 'lottie-web';

const container = document.getElementById('webanim20');

const animationData = {
	v: '5.6.5',
	fr: 30,
	ip: 0,
	op: 326,
	w: 1080,
	h: 1080,
	ddd: 0,
	assets: [],
	layers: [
		{
			ddd: 0,
			ind: 1,
			ty: 3,
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: {
					a: 1,
					k: [
						{
							i: { x: [0.667], y: [1] },
							o: { x: [0.333], y: [0] },
							t: 112,
							s: [0],
						},
						{
							i: { x: [0.833], y: [1] },
							o: { x: [0.333], y: [0] },
							t: 142,
							s: [90],
						},
						{
							i: { x: [0.833], y: [1] },
							o: { x: [0.167], y: [0] },
							t: 172,
							s: [90],
						},
						{ t: 202, s: [180] },
					],
					ix: 10,
				},
				p: { a: 0, k: [540, 540, 0], ix: 2 },
				a: { a: 0, k: [50, 50, 0], ix: 1 },
				s: { a: 0, k: [100, 100, 100], ix: 6 },
			},
			ao: 0,
			ip: 0,
			op: 326,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 2,
			ty: 4,
			parent: 1,
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 50,
							s: [-157.75, 50, 0],
							to: [43.5, 0, 0],
							ti: [5.167, 0, 0],
						},
						{ t: 80, s: [103.25, 50, 0], h: 1 },
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 82,
							s: [103.25, 50, 0],
							to: [-5.167, 0, 0],
							ti: [48.667, 0, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 112,
							s: [-188.75, 50, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 142,
							s: [-188.75, 50, 0],
							to: [12.833, 0, 0],
							ti: [-12.833, 0, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 172,
							s: [-111.75, 50, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 233,
							s: [-111.75, 50, 0],
							to: [8.667, -2.667, 0],
							ti: [-8.667, 2.667, 0],
						},
						{ t: 262, s: [-59.75, 34, 0] },
					],
					ix: 2,
				},
				a: { a: 0, k: [16, 33, 0], ix: 1 },
				s: { a: 0, k: [-1000, 1000, 100], ix: 6 },
			},
			ao: 0,
			hasMask: true,
			masksProperties: [
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 1,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[21.3, 1.4],
											[13.284, 0.9],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 5,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 288,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 289,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[0.687, 61.263],
											[-4.477, 61.267],
											[-4.092, 65.941],
											[0.249, 65.879],
										],
										c: true,
									},
								],
							},
							{
								t: 291,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[20.621, 61.01],
											[-4.477, 61.267],
											[-4.092, 65.941],
											[20.183, 65.627],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 5,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[1.9, 61.15],
											[1.9, 65.944],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 7,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 290,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 291,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15.802, 67.104],
											[12.058, 66.499],
											[11.806, 69.022],
											[15.198, 69.779],
										],
										c: true,
									},
								],
							},
							{
								t: 295,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[32.457, -2.289],
											[28.712, -2.893],
											[11.553, 69.022],
											[15.198, 69.779],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 7,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[13.2, 63.959],
											[17.448, 64.659],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 11,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 294,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 295,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[34.648, 3.3],
											[32.5, 2.2],
											[31.3, 5.559],
											[34.448, 5.559],
										],
										c: true,
									},
								],
							},
							{
								t: 297,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[34.648, 3.3],
											[14.6, 2.6],
											[15, 4.859],
											[34.548, 5.059],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 11,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[38.2, 0.3],
											[10.485, 0.3],
											[10.485, 4.704],
											[38.2, 4.704],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 13,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 296,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 297,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[20.3, -2.5],
											[15.785, -2.9],
											[15.785, 1.504],
											[20.3, 1.904],
										],
										c: true,
									},
								],
							},
							{
								t: 301,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[21.4, -2.7],
											[15.785, -2.9],
											[0.085, 65.304],
											[5.2, 65.804],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
			],
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									v: [
										[-1.356, 29.164],
										[-12.208, 29.164],
										[1.357, -29.164],
										[12.208, -29.164],
									],
									c: true,
								},
								ix: 2,
							},
							hd: false,
						},
						{
							ty: 'st',
							c: {
								a: 0,
								k: [0.989184330959, 0.185860712388, 0.13607227101, 1],
								ix: 3,
							},
							o: { a: 0, k: 100, ix: 4 },
							w: { a: 0, k: 1.5, ix: 5 },
							lc: 1,
							lj: 1,
							ml: 10,
							bm: 0,
							hd: false,
						},
						{
							ty: 'tr',
							p: { a: 0, k: [15.958, 32.914], ix: 2 },
							a: { a: 0, k: [0, 0], ix: 1 },
							s: { a: 0, k: [100, 100], ix: 3 },
							r: { a: 0, k: 0, ix: 6 },
							o: { a: 0, k: 100, ix: 7 },
							sk: { a: 0, k: 0, ix: 4 },
							sa: { a: 0, k: 0, ix: 5 },
						},
					],
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					hd: false,
				},
			],
			ip: 0,
			op: 326,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 3,
			ty: 4,
			parent: 1,
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: {
					a: 1,
					k: [
						{
							i: { x: [0.667], y: [1] },
							o: { x: [0.333], y: [0] },
							t: 142,
							s: [0],
						},
						{ t: 172, s: [149] },
					],
					ix: 10,
				},
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 50,
							s: [-18.5, 50, 0],
							to: [63.833, 0, 0],
							ti: [-33.333, 0, 0],
						},
						{ t: 80, s: [364.5, 50, 0], h: 1 },
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 82,
							s: [364.5, 50, 0],
							to: [33.333, 0, 0],
							ti: [30.5, 0, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 112,
							s: [181.5, 50, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 142,
							s: [181.5, 50, 0],
							to: [-12.5, -0.333, 0],
							ti: [12.5, 0.333, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 163,
							s: [106.5, 48, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 233,
							s: [106.5, 48, 0],
							to: [8.667, -2.667, 0],
							ti: [-8.667, 2.667, 0],
						},
						{ t: 262, s: [158.5, 32, 0] },
					],
					ix: 2,
				},
				a: { a: 0, k: [16, 33, 0], ix: 1 },
				s: { a: 0, k: [1000, 1000, 100], ix: 6 },
			},
			ao: 0,
			hasMask: true,
			masksProperties: [
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 13,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[21.3, 1.4],
											[13.284, 0.9],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 17,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 279,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 280,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[25.413, -3.082],
											[19.996, -3.582],
											[16.596, -1.937],
											[23.713, -0.737],
										],
										c: true,
									},
								],
							},
							{
								t: 283,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[2.386, 65.47],
											[-3.031, 64.97],
											[19.205, -4.336],
											[26.321, -3.136],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 17,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[1.9, 61.15],
											[1.9, 65.944],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 19,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 282,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 283,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[-2.454, 54.177],
											[-3.927, 54.077],
											[-3.927, 58.871],
											[-2.554, 58.871],
										],
										c: true,
									},
								],
							},
							{
								t: 285,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[16.481, 65.369],
											[-3.172, 53.598],
											[-5.745, 59.179],
											[15.283, 70.337],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 19,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[13.2, 63.959],
											[17.448, 64.659],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 23,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 284,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 285,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[12.282, 69.25],
											[7.834, 69.65],
											[7.534, 69.71],
											[11.782, 70.41],
										],
										c: true,
									},
								],
							},
							{
								t: 289,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[11.115, 70.416],
											[7.4, 68.93],
											[29.594, 0.51],
											[34.155, 3.13],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 23,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[38.2, 0.3],
											[10.485, 0.3],
											[10.485, 4.704],
											[38.2, 4.704],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 25,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 277,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 278,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[37.451, 8.26],
											[34.069, 5.974],
											[33.245, 10.583],
											[35.941, 12.457],
										],
										c: true,
									},
								],
							},
							{
								t: 280,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[34.811, 6.44],
											[16.56, -2.744],
											[16.527, 1.04],
											[34.405, 11.087],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
			],
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									v: [
										[-1.356, 29.164],
										[-12.208, 29.164],
										[1.357, -29.164],
										[12.208, -29.164],
									],
									c: true,
								},
								ix: 2,
							},
							hd: false,
						},
						{
							ty: 'st',
							c: {
								a: 0,
								k: [0.989184330959, 0.185860712388, 0.13607227101, 1],
								ix: 3,
							},
							o: { a: 0, k: 100, ix: 4 },
							w: { a: 0, k: 1.5, ix: 5 },
							lc: 1,
							lj: 1,
							ml: 10,
							bm: 0,
							hd: false,
						},
						{
							ty: 'tr',
							p: { a: 0, k: [15.958, 32.914], ix: 2 },
							a: { a: 0, k: [0, 0], ix: 1 },
							s: {
								a: 1,
								k: [
									{
										i: { x: [0.833, 0.833], y: [0.833, 0.833] },
										o: { x: [0.167, 0.167], y: [0.167, 0.167] },
										t: 155,
										s: [100, 100],
									},
									{ t: 156, s: [-100, 100] },
								],
								ix: 3,
							},
							r: {
								a: 1,
								k: [
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 155,
										s: [0],
									},
									{ t: 156, s: [31] },
								],
								ix: 6,
							},
							o: { a: 0, k: 100, ix: 7 },
							sk: { a: 0, k: 0, ix: 4 },
							sa: { a: 0, k: 0, ix: 5 },
						},
					],
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					hd: false,
				},
			],
			ip: 11,
			op: 326,
			st: 11,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 4,
			ty: 4,
			parent: 1,
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [1] },
							o: { x: [0.333], y: [0] },
							t: 233,
							s: [0],
						},
						{ t: 262, s: [103] },
					],
					ix: 10,
				},
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 50,
							s: [119.5, 50, 0],
							to: [-20.833, 0, 0],
							ti: [33.333, 0, 0],
						},
						{ t: 80, s: [-5.5, 50, 0], h: 1 },
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 82,
							s: [-5.5, 50, 0],
							to: [-33.333, 0, 0],
							ti: [12.5, 0, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 112,
							s: [-80.5, 50, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 142,
							s: [-80.5, 50, 0],
							to: [12.833, 0, 0],
							ti: [-12.833, 0, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 172,
							s: [-3.5, 50, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.167, y: 0 },
							t: 187,
							s: [-3.5, 50, 0],
							to: [-2.333, -10, 0],
							ti: [2.333, 10, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.167, y: 0.167 },
							t: 217,
							s: [-17.5, -10, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.167, y: 0 },
							t: 233,
							s: [-17.5, -10, 0],
							to: [8.833, -10.333, 0],
							ti: [-8.833, 10.333, 0],
						},
						{ t: 262, s: [35.5, -72, 0] },
					],
					ix: 2,
				},
				a: { a: 0, k: [16, 33, 0], ix: 1 },
				s: { a: 0, k: [-1000, 1000, 100], ix: 6 },
			},
			ao: 0,
			hasMask: true,
			masksProperties: [
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 25,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[21.3, 1.4],
											[13.284, 0.9],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 29,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 312,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 313,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[20.158, -1.977],
											[14.742, -2.477],
											[11.342, -0.831],
											[19.478, 0.399],
										],
										c: true,
									},
								],
							},
							{
								t: 317,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[20.158, -1.977],
											[14.742, -2.477],
											[-0.447, 66.236],
											[4.451, 65.487],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 29,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[1.9, 61.15],
											[1.9, 65.944],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 31,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 316,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 317,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[-1.01, 60.384],
											[-2.483, 60.284],
											[-2.483, 65.078],
											[-1.11, 65.078],
										],
										c: true,
									},
								],
							},
							{
								t: 319,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[21.087, 61.585],
											[-2.483, 60.284],
											[-2.483, 65.078],
											[20.732, 65.604],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 31,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[13.2, 63.959],
											[17.448, 64.659],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 35,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 318,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 319,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15.867, 66.522],
											[11.419, 66.922],
											[11.119, 66.982],
											[15.367, 67.682],
										],
										c: true,
									},
								],
							},
							{
								t: 323,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[30.999, -0.799],
											[27.87, 0.111],
											[11.119, 66.982],
											[15.367, 67.682],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 22,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[38.2, 0.3],
											[10.485, 0.3],
											[10.485, 4.704],
											[38.2, 4.704],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 24,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 322,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 323,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[36.961, 2.486],
											[32.446, 2.086],
											[32.446, 6.49],
											[36.961, 6.89],
										],
										c: true,
									},
								],
							},
							{
								t: 325,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[36.961, 2.486],
											[14.533, 1.44],
											[10.05, 4.809],
											[36.961, 6.89],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
			],
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									v: [
										[-1.356, 29.164],
										[-12.208, 29.164],
										[1.357, -29.164],
										[12.208, -29.164],
									],
									c: true,
								},
								ix: 2,
							},
							hd: false,
						},
						{
							ty: 'st',
							c: {
								a: 0,
								k: [0.989184330959, 0.185860712388, 0.13607227101, 1],
								ix: 3,
							},
							o: { a: 0, k: 100, ix: 4 },
							w: { a: 0, k: 1.5, ix: 5 },
							lc: 1,
							lj: 1,
							ml: 10,
							bm: 0,
							hd: false,
						},
						{
							ty: 'tr',
							p: { a: 0, k: [15.958, 32.914], ix: 2 },
							a: { a: 0, k: [0, 0], ix: 1 },
							s: { a: 0, k: [100, 100], ix: 3 },
							r: { a: 0, k: 0, ix: 6 },
							o: { a: 0, k: 100, ix: 7 },
							sk: { a: 0, k: 0, ix: 4 },
							sa: { a: 0, k: 0, ix: 5 },
						},
					],
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					hd: false,
				},
			],
			ip: 25,
			op: 326,
			st: 22,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 5,
			ty: 4,
			parent: 1,
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: {
					a: 1,
					k: [
						{
							i: { x: [0.667], y: [1] },
							o: { x: [0.333], y: [0] },
							t: 142,
							s: [0],
						},
						{
							i: { x: [0.667], y: [0.017] },
							o: { x: [0.333], y: [0] },
							t: 172,
							s: [149],
						},
						{
							i: { x: [0.667], y: [0.984] },
							o: { x: [0.333], y: [0.016] },
							t: 232,
							s: [149],
						},
						{
							i: { x: [0.833], y: [1] },
							o: { x: [0.333], y: [0.005] },
							t: 233,
							s: [149],
						},
						{ t: 262, s: [252] },
					],
					ix: 10,
				},
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 50,
							s: [258.75, 50, 0],
							to: [-87, 0, 0],
							ti: [-5.167, 0, 0],
						},
						{ t: 80, s: [-263.25, 50, 0], h: 1 },
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 82,
							s: [-263.25, 50, 0],
							to: [5.167, 0, 0],
							ti: [-92.167, 0, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 112,
							s: [289.75, 50, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 142,
							s: [289.75, 50, 0],
							to: [-12.5, -0.333, 0],
							ti: [12.5, 0.333, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.333, y: 0.333 },
							t: 163,
							s: [214.75, 48, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 202,
							s: [214.75, 48, 0],
							to: [-2.333, -10, 0],
							ti: [2.333, 10, 0],
						},
						{
							i: { x: 0.667, y: 0.667 },
							o: { x: 0.167, y: 0.167 },
							t: 232,
							s: [200.75, -12, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.667, y: 1 },
							o: { x: 0.167, y: 0 },
							t: 233,
							s: [200.75, -12, 0],
							to: [-22, 25.667, 0],
							ti: [22, -25.667, 0],
						},
						{ t: 262, s: [68.75, 142, 0] },
					],
					ix: 2,
				},
				a: { a: 0, k: [16, 33, 0], ix: 1 },
				s: { a: 0, k: [1000, 1000, 100], ix: 6 },
			},
			ao: 0,
			hasMask: true,
			masksProperties: [
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 35,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[21.3, 1.4],
											[13.284, 0.9],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 39,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 300,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.5, 65.3],
											[2.084, 64.8],
											[-1.316, 66.445],
											[5.8, 67.645],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 301,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[13.47, 67.242],
											[8.833, 66.922],
											[8.071, 69.587],
											[12.669, 71.026],
										],
										c: true,
									},
								],
							},
							{
								t: 305,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[33.547, 5.268],
											[29.626, 3.668],
											[9.438, 66.414],
											[13.164, 69.505],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 39,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[1.9, 61.15],
											[1.9, 65.944],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 41,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 304,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.073, 61.3],
											[16.6, 61.2],
											[16.6, 65.994],
											[17.973, 65.994],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 305,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[34.823, 7.165],
											[33.154, 7.02],
											[32.405, 10.615],
											[36.432, 12.459],
										],
										c: true,
									},
								],
							},
							{
								t: 307,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[35.198, 6.656],
											[13.328, -5.218],
											[14.302, -0.199],
											[35.41, 12.499],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 41,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[13.2, 63.959],
											[17.448, 64.659],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 45,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 306,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[31.748, 0.4],
											[27.3, 0.8],
											[27, 0.859],
											[31.248, 1.559],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 307,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[24.2, -3.457],
											[19.752, -3.057],
											[19.452, -2.998],
											[23.7, -2.298],
										],
										c: true,
									},
								],
							},
							{
								t: 311,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[24.314, -2.633],
											[20.802, -6.291],
											[-2.271, 64.649],
											[2.112, 64.764],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
				{
					inv: false,
					mode: 's',
					pt: {
						a: 1,
						k: [
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 45,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[38.2, 0.3],
											[10.485, 0.3],
											[10.485, 4.704],
											[38.2, 4.704],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 47,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 310,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15, 0.7],
											[10.485, 0.3],
											[10.485, 4.704],
											[15, 5.104],
										],
										c: true,
									},
								],
							},
							{
								i: { x: 0.667, y: 1 },
								o: { x: 0.333, y: 0 },
								t: 311,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[-0.174, 53.901],
											[-2.98, 54.101],
											[-5.633, 61.997],
											[-2.602, 60.823],
										],
										c: true,
									},
								],
							},
							{
								t: 313,
								s: [
									{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[18.283, 64.642],
											[-0.57, 54.967],
											[-1.694, 58.907],
											[16.357, 68.935],
										],
										c: true,
									},
								],
							},
						],
						ix: 1,
					},
					o: { a: 0, k: 100, ix: 3 },
					x: { a: 0, k: 0, ix: 4 },
				},
			],
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									v: [
										[-1.356, 29.164],
										[-12.208, 29.164],
										[1.357, -29.164],
										[12.208, -29.164],
									],
									c: true,
								},
								ix: 2,
							},
							hd: false,
						},
						{
							ty: 'st',
							c: {
								a: 0,
								k: [0.989184330959, 0.185860712388, 0.13607227101, 1],
								ix: 3,
							},
							o: { a: 0, k: 100, ix: 4 },
							w: { a: 0, k: 1.5, ix: 5 },
							lc: 1,
							lj: 1,
							ml: 10,
							bm: 0,
							hd: false,
						},
						{
							ty: 'tr',
							p: { a: 0, k: [15.958, 32.914], ix: 2 },
							a: { a: 0, k: [0, 0], ix: 1 },
							s: {
								a: 1,
								k: [
									{
										i: { x: [0.833, 0.833], y: [0.833, 0.833] },
										o: { x: [0.167, 0.167], y: [0.167, 0.167] },
										t: 155,
										s: [100, 100],
									},
									{ t: 156, s: [-100, 100] },
								],
								ix: 3,
							},
							r: {
								a: 1,
								k: [
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 155,
										s: [0],
									},
									{ t: 156, s: [31] },
								],
								ix: 6,
							},
							o: { a: 0, k: 100, ix: 7 },
							sk: { a: 0, k: 0, ix: 4 },
							sa: { a: 0, k: 0, ix: 5 },
						},
					],
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					hd: false,
				},
			],
			ip: 33,
			op: 326,
			st: 33,
			bm: 0,
		},
	],
	markers: [
		{ tm: 50, cm: '0', dr: 0 },
		{ tm: 150, cm: '1', dr: 0 },
		{ tm: 495, cm: '2', dr: 0 },
	],
};

lottie.loadAnimation({
	container,
	renderer: 'svg',
	loop: true,
	autoplay: true,
	animationData,
});
